/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */
/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */
// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript';
// @ts-ignore
import request from "./request";
const mockUrl_0_0_0_0 = "http://yapi.yishou.com/mock/205";
const devUrl_0_0_0_0 = "";
const prodUrl_0_0_0_0 = "";
const dataKey_0_0_0_0 = "data";
/**
 * 接口 [获取操作原因选择项树↗](http://yapi.yishou.com/project/205/interface/api/35707) 的 **请求配置**
 *
 * @分类 [系统公共配置↗](http://yapi.yishou.com/project/205/interface/api/cat_3652)
 * @请求头 `GET /modi/system_field/operation_reason_option`
 */
const operationReasonOptionRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/modi/system_field/operation_reason_option",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: ["query_scope", "key"],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["query_scope", "key"],
        properties: {
            query_scope: { type: "string", description: "是否获取全部（包括已删除的）  1 只获取正常数据 2 全部" },
            key: { type: "string", description: "操作原因的key" },
        },
    },
    responseDataJsonSchema: {
        type: "array",
        items: {
            type: "object",
            properties: {
                rdid: { type: "number", description: "选项id" },
                rdname: { type: "string", description: "选项名称" },
                parent_rdid: { type: "number", description: "选项父级ID" },
                sort: { type: "number", description: "排序" },
                children: { type: "array", items: { type: "string" }, description: "选项子级（架构和当前一样）" },
            },
            required: ["rdid", "rdname", "parent_rdid", "sort", "children"],
        },
    },
    requestFunctionName: "operationReasonOption",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [获取操作原因选择项树↗](http://yapi.yishou.com/project/205/interface/api/35707) 的 **请求函数**
 *
 * @分类 [系统公共配置↗](http://yapi.yishou.com/project/205/interface/api/cat_3652)
 * @请求头 `GET /modi/system_field/operation_reason_option`
 */
export const operationReasonOption = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(operationReasonOptionRequestConfig, requestData), ...args);
};
operationReasonOption.requestConfig = operationReasonOptionRequestConfig;
/* prettier-ignore-end */



// WEBPACK FOOTER //
// ./src/controller/modiCommonConfig3652.js